import {
  Order,
  OrderPackageSize,
  UpdateOrderRequest,
} from '../../../../types/orderTypes';

export type FormOrderDeliveryType = 'Express' | 'Scheduled';

// TODO This should be changed to the Destination/Origin object ?
export interface EditAddress {
  name: string;
  email: string;
  areaCode: string;
  phone: string;
  streetName: string;
  streetNumber: string;
  postalCode: string;
  city: string;
  country: string;
}

export interface OrderForm {
  sender: EditAddress;
  recipient: EditAddress;
  warehouse: EditAddress;
  deliveryFromDate: string;
  deliveryUntilDate: string;
  packageSize: OrderPackageSize;
  packageCount: number;
  type: FormOrderDeliveryType;
  noteForCourier: string;
}

export function orderFormToUpdateRequest(
  order: Order,
  orderForm: OrderForm
): UpdateOrderRequest {
  return {
    origin: {
      name: orderForm.sender.name,
      phoneCountryCode: orderForm.sender.areaCode,
      phoneNumber: orderForm.sender.phone,
      address: {
        country: orderForm.sender.country,
        postalCode: orderForm.sender.postalCode,
        city: orderForm.sender.city,
        streetName: orderForm.sender.streetName,
        streetNumber: orderForm.sender.streetNumber,
      },
      email: orderForm.sender.email,
    },
    destination: {
      name: orderForm.recipient.name,
      phoneCountryCode: orderForm.recipient.areaCode,
      phoneNumber: orderForm.recipient.phone,
      address: {
        country: orderForm.recipient.country,
        postalCode: orderForm.recipient.postalCode,
        city: orderForm.recipient.city,
        streetName: orderForm.recipient.streetName,
        streetNumber: orderForm.recipient.streetNumber,
      },
      email: orderForm.recipient.email,
      deliveryWindow: {
        start: orderForm.deliveryFromDate,
        end: orderForm.deliveryUntilDate,
      },
      verifications: {
        leaveAtDoorstep: false,
      },
    },
    warehouse: {
      name: orderForm.warehouse.name,
      phoneCountryCode: orderForm.warehouse.areaCode,
      phoneNumber: orderForm.warehouse.phone,
      address: {
        country: orderForm.warehouse.country,
        postalCode: orderForm.warehouse.postalCode,
        city: orderForm.warehouse.city,
        streetName: orderForm.warehouse.streetName,
        streetNumber: orderForm.warehouse.streetNumber,
      },
      email: orderForm.warehouse.email,
    },
    courierInstructions: orderForm.noteForCourier || '',
    product: orderForm.type === 'Express' ? 'EXPRESS' : 'DELIVERY',
    packagesNumber: orderForm.packageCount,
    packageSize: orderForm.packageSize,
  };
}
